export enum UserGroup {
  Owner = '/Launcher/Launcher. Полный доступ',
  Admin = '/Launcher/Launcher. Администрирование',
  Common = '/Launcher/Launcher. Общее',
  Innovation = '/Launcher/Launcher. ДИТ. Инновации',
  Office = '/Launcher/Launcher. Офис',
  Personal = '/Launcher/Launcher. Персональный доступ',
  Chats = '/Launcher/Launcher. Чаты',
  Applications = '/Launcher/Launcher. Приложения',
  UserGroups = '/Launcher/Launcher. Группы пользователей',
  Notifications = '/Launcher/Launcher. Уведомления',
}

export interface IUserGroup {
  id: string;
  name: string;
  path: `${UserGroup}`;
  updatedAt: string;
  createdAt: string;
}
